var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    !_vm.isForm
      ? _c(
          "a",
          {
            staticClass: "btn",
            class: _vm.cssClasses + (_vm.disabled ? " disabled" : ""),
            attrs: {
              "aria-disabled": _vm.disabled,
              "aria-label": _vm.ariaLabel,
              href: _vm.actionUrl,
              "data-oevent-category": _vm.tmsData.category,
              "data-oevent-action": _vm.tmsData.action,
              "data-oevent-label": _vm.tmsData.label,
              role: _vm.isRoleButton ? "button" : null,
              "data-bs-toggle": _vm.isModalOpener ? "modal" : null,
            },
          },
          [
            _c("span", { class: { "d-lg-none": _vm.withDesktopButton } }, [
              _vm._v(_vm._s(_vm.buttonLabel)),
            ]),
            _vm._v(" "),
            _vm.withDesktopButton
              ? _c("span", { staticClass: "d-none d-lg-inline-block" }, [
                  _vm._v(_vm._s(_vm.desktopButtonLabel)),
                ])
              : _vm._e(),
          ]
        )
      : _c(
          "form",
          {
            attrs: {
              method: "post",
              role: "form",
              "aria-label": "Formulaire " + _vm.buttonLabel,
              action: _vm.actionUrl,
            },
          },
          [
            _c("input", {
              attrs: { type: "hidden", name: "token" },
              domProps: { value: _vm.token },
            }),
            _vm._v(" "),
            _vm._l(_vm.actionFormParams, function (value, name) {
              return _c("input", {
                attrs: { type: "hidden", name: name },
                domProps: { value: value },
              })
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn",
                class: _vm.cssClasses + (_vm.disabled ? " disabled" : ""),
                attrs: {
                  type: "submit",
                  "aria-disabled": _vm.disabled,
                  "aria-label": _vm.ariaLabel,
                  "data-oevent-category": _vm.tmsData.category,
                  "data-oevent-action": _vm.tmsData.action,
                  "data-oevent-label": _vm.tmsData.label,
                },
              },
              [
                _c("span", { class: { "d-lg-none": _vm.withDesktopButton } }, [
                  _vm._v(_vm._s(_vm.buttonLabel)),
                ]),
                _vm._v(" "),
                _vm.withDesktopButton
                  ? _c("span", { staticClass: "d-none d-lg-inline-block" }, [
                      _vm._v(_vm._s(_vm.desktopButtonLabel)),
                    ])
                  : _vm._e(),
              ]
            ),
          ],
          2
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }